module.exports = __webpack_public_path__ + "img/18.77718e97.jpg";